import Line from './index.vue'
const codes = ['zxt001', 'zxt002', 'zxt003', 'zxt004']

export function installLine() {
  return codes.map(code => {
    const nameCode = code[0].toUpperCase() + code.substring(1)
    const name = `KyeReport${nameCode}`
    return {
      name,
      extends: Line,
      data() {
        return {
          code,
        }
      },
    }
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/line/install.js